module.exports = __webpack_public_path__ + "static/img/decoration.de68585.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/decoration.png
// module id = C48C
// module chunks = 1